import { fetchApi } from '@/config/axiosSetting';
import { PatchInitialVisitVehiclePartTwoQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchInitialVisitVehiclePartTwo/patchInitialVisitVehiclePartTwoQuery.type';

export const patchInitialVisitVehiclePartTwoFunction = (
  params: PatchInitialVisitVehiclePartTwoQueryParamsType,
) => {
  return fetchApi.patch(
    `/initial/reports/${params.id}/vehicle_information/part_two/`,
    params.data,
    { params: { id: params.id } },
  );
};
